__turbopack_context__.v({
  "className": "caveat_340d9820-module__RnFWKW__className",
});
